import { formUseCaseProviders } from './form.provider';
import { questionUseCaseProviders } from './question.provider';
import { userUseCaseProviders } from './user.provider';
import { folderUseCaseProviders } from './folder.provider';
import { spaceObjectsSearchUseCaseProviders } from './space.provider';
import { fillInBlankQuestionUseCaseProviders } from './fill-in-blank.provider';
import { assignmentUseCaseProviders } from './assignment.provider';
import { assignmentConfigurationUseCaseProviders } from './assignment-configuration.provider';
import { submissionUseCaseProviders } from './submission.provider';
import { authenticationUseCaseProviders } from './authentication.provider';
import { formReleaseUseCaseProviders } from './form-release.provider';
import { questionReleaseUseCaseProviders } from './question-release.provider';
import { fileStorageUseCaseProviders } from './file-storage.provider';
import { reportUseCaseProviders } from './report.provider';
import { answerUseCaseProviders } from './answer.provider';
import { securityOptionUseCaseProviders } from './security-option.provider';
import { examinationSubmissionUseCaseProviders } from './examination-submission.provider';
import { globalFormUseCaseProviders } from './global-form.provider';
import { tagUseCaseProviders } from './tag.provider';
import { formCategoryUseCaseProviders } from './form-category.provider';
import { headingUseCaseProviders } from './heading.provider';
import { aiResourceChangesUseCaseProviders } from './ai-resource-changes.provider';
import { aiChatAppUseCaseProviders } from '@module/ai-chat-app';
import { fileManagementAppUseCaseProviders } from '@module/file-management-app';
import { classUseCaseProviders } from './class.provider';

export const useCaseProviders = [
  // Identity
  ...authenticationUseCaseProviders,
  ...userUseCaseProviders,

  // AI Chat v2
  ...aiChatAppUseCaseProviders,
  ...aiResourceChangesUseCaseProviders,

  // File Management App
  ...fileManagementAppUseCaseProviders,

  // Form
  ...formUseCaseProviders,
  ...folderUseCaseProviders,
  ...questionUseCaseProviders,
  ...spaceObjectsSearchUseCaseProviders,
  ...fillInBlankQuestionUseCaseProviders,

  ...formReleaseUseCaseProviders,
  ...questionReleaseUseCaseProviders,
  ...globalFormUseCaseProviders,
  ...formCategoryUseCaseProviders,
  ...tagUseCaseProviders,
  ...headingUseCaseProviders,

  // File Storage
  ...fileStorageUseCaseProviders,

  // Assignment
  ...reportUseCaseProviders,
  ...answerUseCaseProviders,
  ...securityOptionUseCaseProviders,
  ...examinationSubmissionUseCaseProviders,
  ...assignmentUseCaseProviders,
  ...assignmentConfigurationUseCaseProviders,
  ...submissionUseCaseProviders,
  ...classUseCaseProviders,
];

export const noAuthUseCaseProviders = [
  ...globalFormUseCaseProviders,
  ...formCategoryUseCaseProviders,
  ...tagUseCaseProviders,
];
